import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { DropdownItem } from 'reactstrap';
import { Dispatch } from 'redux';
import { hasPrivilege, adEnabled, ssoEnabled } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import { selected } from '../../../stores/tables/selectors';
import { sendVerifyEmailMail } from '../../../stores/users/actionCreators';
import ConfirmModal from '../../common/modals/ConfirmModal';

interface Props extends LocalizeContextProps {
    selected: string[];

    sendVerifyEmailMail: (ids: string[]) => void;
}
interface State {
    showModal: boolean;
}

class SendVerifyEmailMailAction extends React.Component<Props, State> {
    public constructor(props: Props) {
        super(props);
        this.state = {
            showModal: false,
        };
    }

    public render() {
        const t = this.props.translate;
            return (
                <React.Fragment>
                    <DropdownItem
                        onClick={() => {
                            this.setState({ showModal: true });
                        }}
                    >
                        <FontAwesomeIcon icon={['fal', 'envelope-open']} />
                        {t('users.button.sendVerifyEmailMail')}
                    </DropdownItem>
                    <ConfirmModal
                        header={t('users.modal.mail.header') as string}
                        confirmText={t('users.modal.mail.mail') as string}
                        isOpen={this.state.showModal}
                        confirm={() => {
                            this.props.sendVerifyEmailMail(this.props.selected);
                        }}
                        cancel={() => { this.setState({ showModal: false }); }}
                    >
                        {t('users.modal.mail.text') as string}
                    </ConfirmModal>
                </React.Fragment>
            );
    }
}

const mapStateToProps = (state: RootState) => ({
    selected: selected(state, 'users'),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    sendVerifyEmailMail: (ids: string[]) => dispatch(sendVerifyEmailMail(ids)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(SendVerifyEmailMailAction));